module.exports = __webpack_public_path__ + "static/media/we-left-bottom.9b62090c.png";